<script>
    export default {
        data() {
            return {
                enableFilter: true,
            }
        },
        computed: {
            filterValue() {return this.file.filter[this.filter.id]}
        },
        props: {
            file: Object,
            filter: Object,
            filterItem: Object,
        },
        async mounted() {
            await this.checkParent();
        },
        methods: {
            async changeInput(event) {
                this.file.updateFilter(
                    this.filter.id, 
                    Number(event.target.value),
                    event.target.checked
                );
            },
            async checkParent() {
                if (this.filterItem.parent_ids == null) return;
                
                let parentNotFound = false;
                this.filterItem.parent_ids.forEach((parentValue, parentIndex) => {
                    if (this.file.selectFilter.includes(parentValue) === true) {
                        parentNotFound = true;
                    }
                });

                if (parentNotFound === false) {
                    if (this.file.filter[this.filter.id] === this.filterItem.id) {
                        this.file.updateFilter(this.filter.id, NaN, true);
                    }
                }
                
                this.enableFilter = parentNotFound;
            }
        },
        watch: {
            'file.selectFilter': {
                handler: async function(newValue, oldValue) {
                    await this.checkParent();
                },
                deep: true
            }
        }
    }
</script>


<template>
    <li>
        <input 
            :disabled="enableFilter === false"
            :type="filter['is_multiple'] === false ? 'radio' : 'checkbox'"
            :checked="filter['is_multiple'] === false ? filterValue === filterItem.id : filterValue.includes(filterItem.id)"
            :id = "`${file['id']}-${filterItem['id']}`"
            :value = "filterItem['id']"
            :name = "`${file['id']}-${filter['id']}`"
            @change = "changeInput"
        >
        <label 
            :class="enableFilter === true ? 'ml_5' : 'ml_5 disable_filter_text'" 
            :for = "`${file['id']}-${filterItem['id']}`"
        >{{ filterItem['name'] }}
        </label>
    </li>
</template>


<style scoped>
    .disable_filter_text {
        color: var(--filter-text-disable);
    }
</style>